import {wrap} from "../../utils/wrap";

const contribution = () => {
    // Traitement rédactionnel
    const tables = document.querySelectorAll('.txt table:not(.tableNotResponsive), .partage table:not(.tableNotResponsive), .tpl table:not(.tableNotResponsive)');
    tables.forEach(table => {
        const div = document.createElement('div');
        div.classList.add('tableauContainer');
        wrap(table, div);
    });
}

document.addEventListener('DOMContentLoaded', contribution);
